import { Observable } from 'rxjs';
import { Country } from '@app/domain/models/country.model';

/**
 * Port abstracto para obtener el catálogo de países (lada + bandera).
 * Las implementaciones (remote/mock) se inyectan vía DI sin que los
 * componentes conozcan el origen de los datos.
 */
export abstract class CountryRepository {
  abstract getCountries(): Observable<Country[]>;
}
